import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  ColorInput,
  Text,
  Select,
  NumberInput,
  Textarea,
} from "@mantine/core";
import classes from "./edit.module.css";
import { RowDataReview } from "./types";
import { DateInput } from "@mantine/dates";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto } from "@tabler/icons-react";
import moment from "moment";

interface EditReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEditBanner: (editedBannerData: RowDataReview) => void;
  bannerData: RowDataReview;
}

const EditReviewModal: React.FC<EditReviewModalProps> = ({
  isOpen,
  onClose,
  onEditBanner,
  bannerData,
}) => {
  const [editedBanner, setEditedBanner] = useState<RowDataReview>(bannerData);

  useEffect(() => {
    setEditedBanner(bannerData);
  }, [bannerData]);


  const handleEdit = () => {
    // Perform validation or additional logic as needed
    onEditBanner(editedBanner);
    onClose();
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Review
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput
        label="Fullname"
        maxLength={255}
        mb="sm"
        value={editedBanner.fullname}
        onChange={(event) =>
          setEditedBanner({ ...editedBanner, fullname: event.currentTarget.value })
        }
      />

        <NumberInput
            label="Rating"
            description="1-5"
            allowDecimal={false}
            allowNegative={false}
            min={1}
            max={5}
            value={editedBanner?.rating}
            mb="sm"
            // onChange={(event) => setGamesFPS((prev)=>[...prev, prev[index].fps])}
            onChange={(e) => setEditedBanner({ ...editedBanner, rating: e })}
        />

<Textarea
        label="Review"
      value={editedBanner?.review}
      onChange={(event) => setEditedBanner({ ...editedBanner, review: event.currentTarget.value })}
      autosize={true}
      minRows={4}
        mb="sm"
    />

<DateInput
        //   valueFormat="YYYY-MM-DD HH:mm:ss.SSS"
        //   dropdownType="modal"
          label="Review Date"
          placeholder="Pick date"
          mb="sm"
          required
          value={new Date(editedBanner?.reviewDate)}
          onChange={(e) =>
            setEditedBanner({
              ...editedBanner,
              reviewDate: moment(e).format("YYYY-MM-DD HH:mm:ss.SSS") ?? "",
            })
          }
        />


      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonCancel}>
          Back
        </Button>
        <Button onClick={handleEdit} className={classes.buttonSaveChanges}>
          Save Changes
        </Button>
      </Group>
    </Modal>
  );
};

export default EditReviewModal;
